import { Warning } from '../../../assets/icons'
import { SVGWrapper } from '../../../components'
import { Section } from '../styles'

const AddAtLeastOneAccount = ({ handleAccountRedirect }) => {
  return (
    <Section.ActionItemsMessage warning>
      <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
      <Section.ActionItemMessageText>
        CRITICAL: Add at least one account intended for living expenses in retirement before
        beginning to plan.{' '}
        <Section.Link onClick={handleAccountRedirect}>Add account now</Section.Link>
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}

export default AddAtLeastOneAccount
